import throttle from 'lodash/throttle';

export const getHashFrom = (link: HTMLAnchorElement) => {
	const selector = link.getAttribute('href');
	if (!selector || selector.indexOf('#') !== 0) return null;
	return selector;
};

export const getTargetOf = (link: HTMLAnchorElement) => {
	const hash = getHashFrom(link);
	if (!hash) return null;

	const target = document.querySelector<HTMLElement>(hash);
	return target;
};

document.addEventListener('DOMContentLoaded', () => {
	const scrollContextEl = document.querySelector<HTMLElement>(
		'[data-scroll-context]',
	);
	if (!scrollContextEl) return;

	const linkEls = scrollContextEl.querySelectorAll<HTMLAnchorElement>(
		'a[href^="#"]',
	);

	const links = Array.from(linkEls)
		.map((linkEl) => ({
			el: linkEl,
			target: getTargetOf(linkEl),
			hash: getHashFrom(linkEl),
		}))
		.filter((link) => link.el && link.target);

	links.forEach((link) => {
		if (link.target) {
			link.el.addEventListener('click', (ev) => {
				ev.preventDefault();
				link.target?.scrollIntoView({ behavior: 'smooth' });
				history.replaceState('', '', link.hash);
			});
		}
	});

	const handleActiveHeading = () => {
		const scrolledPast = links.filter((link) => {
			const rect = link.target?.getBoundingClientRect();
			return (rect?.top || 999999) <= 100;
		});

		const last =
			scrolledPast.length > 0 ? scrolledPast[scrolledPast.length - 1] : null;

		links.forEach((link) => {
			link.el.classList.toggle('scroll-context__link--current', link === last);
		});
	};
	const handleActiveHeadingOnScroll = throttle(handleActiveHeading, 50, {
		trailing: true,
	});
	window.addEventListener('scroll', handleActiveHeadingOnScroll, {
		passive: true,
	});

	const darkEls = Array.from(document.querySelectorAll('[data-section-dark]'));

	const handleDarkSections = () => {
		const contextRect = scrollContextEl.getBoundingClientRect();

		const intersectingAny = darkEls.some((darkEl) => {
			const darkElRect = darkEl.getBoundingClientRect();
			return intersects(contextRect, darkElRect);
		});

		scrollContextEl.classList.toggle(
			'scroll-context--negative',
			intersectingAny,
		);
	};

	const handleDarkSectionsOnScroll = throttle(handleDarkSections, 50, {
		trailing: true,
	});

	window.addEventListener('scroll', handleDarkSectionsOnScroll, {
		passive: true,
	});
});

const intersects = (child: DOMRect, parent: DOMRect): boolean => {
	// Note: only checks vertical intersection
	return (
		child.top + child.height / 2 > parent.top &&
		child.bottom - child.height / 2 < parent.bottom
	);
};
